import { render, staticRenderFns } from "./VerticalNavMenuCgu.vue?vue&type=template&id=1339236e&"
import script from "./VerticalNavMenuCgu.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuCgu.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuCgu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports